module.exports = __webpack_public_path__ + "static/media/teammateUserGray.a5e314a5.svg";